<template>
  <form class="user-form-view custom-layout">
    <Login
      v-show="formName === 'login'"
      @dest="handleDest"
      @login="handleLogin"
    ></Login>
    <Register
      v-show="formName === 'register'"
      @dest="handleDest"
      @register="handleRegister"
    ></Register>
    <Forget
      v-show="formName === 'forget'"
      @dest="handleDest"
      @forget="handleForget"
    ></Forget>
  </form>
</template>

<script>
import Login from "./Login";
import Register from "./Register";
import Forget from "./ForgetPassword";

export default {
  name: "UserForm",
  components: { Login, Register, Forget },
  data() {
    return {
      formName: "register",
    };
  },
  methods: {
    handleDest(dest) {
      this.formName = dest;
    },
    handleLogin(user) {
      this.$emit("finish", { type: "login", user });
    },
    handleRegister(user) {
      this.$emit("finish", { type: "register", user });
    },
    handleForget() {
      this.$emit("finish", { type: "forgetPassword" });
    },
  },
};
</script>

<style lang="scss">
@import '~@/assets/css/layout.scss';

.user-form-view {
  padding:.6rem;
  text-align: left;
  h2 {
    margin-top: 0;
  }
  .actions {
    margin-top: 0.48rem;
    margin-bottom: 0.24rem;
  }
  .footer {
    font-size: 0.373333rem;
    .fa {
      font-size: 0.3rem;
    }
  }
}
</style>